import _memoize from 'lodash/memoize'
import { Map } from 'immutable'

// we need this double memoization because lodash memoize doesn't support multiple arguments
export const getConvertedNodes = _memoize((converter) => {
  return _memoize((state) => {
    if (state === undefined) {
      return Map()
    }

    return state.withMutations((mutableState) => {
      state.mapKeys((id, langMap) => {
        langMap.mapKeys((lang, item) => {
          const isPending = item.get('processing')
          if (isPending) {
            if (langMap.keySeq().size) {
              mutableState.deleteIn([id])
            }
          } else {
            const convertedItem = converter({ id, node: item })
            mutableState.setIn([id, lang], convertedItem)
          }
        })
      })
    })
  })
})

export default getConvertedNodes
